import SmallCalculator from './SmallCalculator';

export default SmallCalculator;
